import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';


@Injectable()
export class TokenInterceptorService implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const userToken = environment.apiBearerToken;
    const modifiedReq = req.clone({
      headers: req.headers.set('Authorization', `bearer ${userToken}`),
    });
    return next.handle(modifiedReq);
  }
}
